import { render, staticRenderFns } from "./plasticMaterial.vue?vue&type=template&id=6265c3a8&scoped=true"
import script from "./plasticMaterial.vue?vue&type=script&lang=js"
export * from "./plasticMaterial.vue?vue&type=script&lang=js"
import style0 from "./plasticMaterial.vue?vue&type=style&index=0&id=6265c3a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6265c3a8",
  null
  
)

export default component.exports